export class taskTransferM{
    CLIENT_ID: number;
    ID: number;
    TASK_ID: number;
    FROM_USER_ID: number;
    TO_USER_ID: number;
    TRANSFER_DATETIME: any;
}